import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { QuillModule } from 'ngx-quill';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DashboardComponent } from '../modules/dashboard/dashboard.component';
import { MainRequestDetailsComponent } from '../modules/workFlow/components/main-request-details/main-request-details.component';
import { RequestHistoryComponent } from '../modules/workFlow/components/request-history/request-history.component';
import { RequestDecisionComponent } from '../modules/workFlow/components/task-decision/request-decision.component';
import { LoginComponent } from './authentication/login/login.component';
import { AttachmentListDetailsComponent } from './components/attachment-list-details/attachment-list-details.component';
import { AttachmentListComponent } from './components/attachment-list/attachment-list.component';
import { AttachmentComponent } from './components/attachment/attachment-input/attachment.component';
import { BreadcrumbComponent } from './components/bread-crump/bread-crumb.component';
import { CharacterCounterComponent } from './components/character-counter/character-counter.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { InlineSpinnerComponent } from './components/inline-spinner/inline-spinner.component';
import { ItemLogsComponent } from './components/item-logs/item-logs.component';
import { LanguageSwitcherComponent } from './components/language-switcher/language-switcher.component';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component';
import { NgbDatepickerComponent } from './components/ngb-datepicker/ngb-datepicker.component';
import { NotificationIconComponent } from './components/notification-icon/notification-icon.component';
import { NotificationItemComponent } from './components/notification-item/notification-item.component';
import { PagerComponent } from './components/pager/pager.component';
import { RichTextEditorComponent } from './components/rich-text-editor/rich-text-editor.component';
import { SurveyQuestionViewerComponent } from './components/survey-question-viewer/survey-question-viewer.component';
import { ArabicDatePipe } from './pipes/arabic-date.pipe';
import { DurationPipe } from './pipes/duration.pipe';
import { InitialsPipe } from './pipes/initials.pipe';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { SubmitRequestComponent } from '../modules/common/components/submit-request/submit-request.component';
import { RequestDetailsComponent } from '../modules/common/components/request-details/request-details.component';
import { ApprovalsHistoryComponent } from '../modules/common/components/approvals-history/approvals-history.component';

@NgModule({
  declarations: [
    PagerComponent,
    LanguageSwitcherComponent,
    LoginComponent,
    HeaderComponent,
    BreadcrumbComponent,
    FooterComponent,
    DashboardComponent,
    AttachmentComponent,
    DropdownComponent,
    AttachmentListComponent,
    AttachmentListDetailsComponent,
    RequestDecisionComponent,
    MainRequestDetailsComponent,
    RequestHistoryComponent,
    ItemLogsComponent,
    CharacterCounterComponent,
    ArabicDatePipe,
    DurationPipe,
    InitialsPipe,
    LocalDatePipe,
    SurveyQuestionViewerComponent,
    MultiSelectDropdownComponent,
    NotificationIconComponent,
    NotificationItemComponent,
    TimeAgoPipe,
    InlineSpinnerComponent,
    RichTextEditorComponent,
    NgbDatepickerComponent,
    SubmitRequestComponent,
    RequestDetailsComponent,
    ApprovalsHistoryComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    NgxSpinnerModule,
    TranslateModule,
    NgApexchartsModule,
    //ToastrModule,
    NgMultiSelectDropDownModule,
    NgbModule,
    QuillModule.forRoot()
  ],
  exports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgApexchartsModule,
    //ToastrModule,
    PagerComponent,
    NgMultiSelectDropDownModule,
    LanguageSwitcherComponent,
    LoginComponent,
    HeaderComponent,
    BreadcrumbComponent,
    FooterComponent,
    AttachmentComponent,
    DropdownComponent,
    AttachmentListComponent,
    AttachmentListDetailsComponent,
    RequestDecisionComponent,
    RequestHistoryComponent,
    ItemLogsComponent,
    CharacterCounterComponent,
    MainRequestDetailsComponent,
    ArabicDatePipe,
    DurationPipe,
    InitialsPipe,
    LocalDatePipe,
    SurveyQuestionViewerComponent,
    MultiSelectDropdownComponent,
    NotificationIconComponent,
    NotificationItemComponent,
    TimeAgoPipe,
    InlineSpinnerComponent,
    RichTextEditorComponent,
    NgbDatepickerComponent,
    SubmitRequestComponent,
    RequestDetailsComponent,
    ApprovalsHistoryComponent
  ],
  providers: [TranslateService],
})
export class SharedModule { }
